export default __webpack_public_path__ + "static/media/erythree_stroke.ce29a2c8.svg";